
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/statistiky/ligy",
      function () {
        return require("private-next-pages/statistiky/ligy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/statistiky/ligy"])
      });
    }
  